// DEPENDS 
import React, {useState, useRef} from 'react';
import { Link } from 'react-router-dom';
// data 
import {guides_1} from '../../../assets/data/guides.js'

// CSS 
import "../../../CSS/TOB/Docs/Wifioption1.css"


const Wifioption1 = () => {
    // used to set which step in the guide that will be shown, default to the first one on the list.
    const idx = useRef(0)
    const [guide, setGuide] = useState(guides_1[idx.current]);
    const idx_capt = useRef(0)

    // for moving steps in teh workflow
    const handleGuide = () => {
            idx.current += 1
            // console.log(idx)
            setGuide(guides_1[idx.current])
            window.scrollTo({
                top: 120,
                behavior: "smooth"
            });
    }

    const handleBack = () => {
        if (idx.current > 0) {
            idx.current -= 1
            // console.log(idx)
            setGuide(guides_1[idx.current])
            window.scrollTo({
                top: 120,
                behavior: "smooth"
            });
        } else {
            window.alert("page error, please reload.")
            return null
        }
    }

    return(
        <div className='Wifioption1'>
            <div className='Wifioption1__return' id="link_wop1Home" style={{display: idx.current === 5 ? "flex" : "none"}}>
                <Link to="/TOBHomes" className='return__link'>Return to the Home Page</Link>
            </div>
            <div className='Wifioption1__guide' style={{display: idx.current === 5 ? "none" : "flex"}}>
                <div className='guide__viewContainer' id={`viewer_op1_${idx.current}`}>
                    
                </div>
                <div className='guide__captions'>
                    <h1 className='captions__title'>{guide.title}</h1>
                    {guide.captions.map((item) => {
                        idx_capt.current += 1
                        return(
                            <p 
                                className='captions__copy' 
                                id={`copy_op1_${idx_capt.current}`} 
                                key={`copy_op1_${idx_capt.current}`}
                            >{item}</p>
                        )
                    })}
                </div>
                <div className='guide__buttonContainer'>
                    <button className='buttonContainer__button' id='button_wifiback' onClick={handleBack} style={{opacity: idx.current > 0 ? "70%" : "0%"}}>Back</button>
                    <button className='buttonContainer__button' id='button_wifinext' onClick={handleGuide}>Next</button>
                </div>
            </div>
        </div>
    );
};

export default Wifioption1;
